import React, { useContext } from 'react';
import { Menu, Icon, Dropdown } from 'semantic-ui-react';
import Logo from '../images/new-logo.png';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/auth';

const MenuBar = () => {
  const context = useContext(AuthContext);
  //const pathname = window.location.pathname;
  //const path = pathname === "/" ? "home" : pathname.substr(1);
  //context.changeActiveMenuItem(path);
  //const [activeItem, setActiveItem] = useState(path);
  //const handleItemClick = (e, {name}) => setActiveItem(name);
  const handleItemClick = (e, { name }) => context.changeActiveMenuItem(name);

  const menuBar = context.user ? (
    <Menu pointing secondary color="teal">
      <Link to={'/'}>
        <img src={Logo} alt="KuickPay Logo" className="logo" />
      </Link>
      <Menu.Item
        className="menu-item"
        name="accounts"
        id="accounts"
        active={context.activeMenuItem === 'accounts'}
        onClick={handleItemClick}
        as={Link}
        to="/accounts"
      />
      <Menu.Item
        className="menu-item"
        name="pay"
        id="pay"
        active={context.activeMenuItem === 'pay'}
        onClick={handleItemClick}
        as={Link}
        to="/pay"
      />
      <Menu.Menu position="right">
        <Dropdown
          id="dropdown-btn"
          trigger={
            <span id="profile_menu_button">
              <Icon name="user" /> {context.user.firstName}
            </span>
          }
          item
          labeled
          simple
        >
          <Dropdown.Menu id="profile_dropdown_menu">
            <Dropdown.Item
              id="user_profile"
              onClick={handleItemClick}
              as={Link}
              to="/profile"
            >
              Profile
            </Dropdown.Item>
            <Dropdown.Item
              id="homeloan"
              onClick={handleItemClick}
              as={Link}
              to="/homeloan"
            >
              Home Loan
            </Dropdown.Item>
            <Dropdown.Item
              id="paytax"
              onClick={handleItemClick}
              as={Link}
              to="/paytax"
            >
              Pay Tax
            </Dropdown.Item>
            <Dropdown.Item
              id="kiwisaver"
              onClick={handleItemClick}
              as={Link}
              to="/kiwisaver"
            >
              KiwiSaver
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item id="logout" onClick={context.logout}>
              Sign out
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Menu.Menu>
    </Menu>
  ) : (
    <div className="header">
      <Menu pointing secondary color="teal">
        <Link to={'/'}>
          <img src={Logo} alt="KuickPay Logo" className="logo" />
        </Link>
        <Menu.Menu position="right">
          <Menu.Item
            className="menu-item"
            name="login"
            id="login"
            active={context.activeMenuItem === 'login'}
            onClick={handleItemClick}
            as={Link}
            to="/login"
          />
          <Menu.Item
            className="menu-item"
            name="register"
            id="register"
            active={context.activeMenuItem === 'register'}
            onClick={handleItemClick}
            as={Link}
            to="/register"
          />
        </Menu.Menu>
      </Menu>
    </div>
  );

  return menuBar;
};

export default MenuBar;
